var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.44 40.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d6c3;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    className: "cls-1",
    d: "M5.82,5.49c-1.51,1.39-2.51,3.65-2.51,7.2V28.14c0,3.54,1,5.8,2.51,7.2s3.81,2.17,6.87,2.17H34.76c3.05,0,5.35-.76,6.87-2.17s2.5-3.66,2.5-7.2V12.69c0-3.55-1-5.81-2.5-7.2s-3.82-2.18-6.87-2.18H12.69C9.63,3.31,7.34,4.07,5.82,5.49ZM3.56,3.06C5.9.89,9.12,0,12.69,0H34.76c3.56,0,6.78.89,9.12,3.06s3.56,5.45,3.56,9.63V28.14c0,4.17-1.2,7.43-3.56,9.62s-5.56,3.06-9.12,3.06H12.69c-3.57,0-6.79-.89-9.13-3.06S0,32.31,0,28.14V12.69C0,8.51,1.2,5.26,3.56,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke__2",
    "data-name": "vector (Stroke)_2",
    className: "cls-1",
    d: "M40,10.06a1.64,1.64,0,0,1-.3,2.32L27.43,21.84a6.06,6.06,0,0,1-7.42,0L7.77,12.38a1.65,1.65,0,1,1,2-2.61L22,19.22a2.76,2.76,0,0,0,3.38,0L37.65,9.77A1.65,1.65,0,0,1,40,10.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmeal);
export default __webpack_public_path__ + "static/media/emeal.8e67d271223566baae08cb017518d030.svg";
export { ForwardRef as ReactComponent };